import React, { useState } from 'react'

const useSearch = () => {
	const [searchText, setSearchText] = useState('')

	const handleSearchChange = (
		e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) => setSearchText(e.target.value)

	const handleClearSearchClick = () => setSearchText('')

	return {
		searchText,
		handleSearchChange,
		handleClearSearchClick,
	}
}

export default useSearch
